import { MatDialog } from '@angular/material/dialog';
import { isEqual } from '@sama/micro-dash';
import { SubscriptionManager } from '@sama/rxjs-core';
import { fromEvent } from 'rxjs';
import { AbstractTrackerWithContext } from '../../../cross-team-shared/event-tracking/abstract-tracker-with-context';
import { DebouncedEventTracker } from '../../../cross-team-shared/event-tracking/debounced-event-tracker';
import { EventTrackingValue } from '../../../team-apis/core/event-tracking';
import { Point2D } from '../../../team-apis/otterdam/answers/shape-typings';

export class ScrollEventsListener {
  private includedWheel = false;
  private eventTracker: DebouncedEventTracker;

  // eslint-disable-next-line max-params-unless-injectable -- we pass things injected elsewhere
  constructor(
    private target: EventTarget,
    private subscriptionManager: SubscriptionManager,
    tracker: AbstractTrackerWithContext,
    subBucket: string,
    private dialog: MatDialog,
  ) {
    this.eventTracker = new DebouncedEventTracker(
      { id: 'scroll_element', bucket: 'navigation', sub_bucket: subBucket },
      tracker,
    );
    this.subscriptionManager.subscribeTo(
      this.eventTracker.afterDebounce$,
      this.reset.bind(this),
    );
  }

  startListening(getPan: () => Point2D, eventValue: EventTrackingValue = {}) {
    this.subscribeToScrolls(getPan, eventValue);
    this.subscribeToWheel();
  }

  private subscribeToScrolls(
    getPan: () => Point2D,
    eventValue: EventTrackingValue,
  ) {
    let lastPan = getPan();
    this.subscriptionManager.subscribeTo(
      fromEvent(this.target, 'scroll'),
      () => {
        const isFirstTime = !this.eventTracker.isDebouncePending();

        // Something in Angular Material or the CDK causes page scroll events to
        // fire when dialogs are opened or closed (window.scrollY is 0 while a
        // dialog with backdrop is open). We skip those here to only track true
        // scroll events.
        if (this.dialog.openDialogs.length || isEqual(lastPan, getPan())) {
          return;
        }

        if (isFirstTime) {
          this.eventTracker.addContext({
            start_x: lastPan[0],
            start_y: lastPan[1],
          });
        }

        lastPan = getPan();
        this.eventTracker.trackWithDebounce({
          end_x: lastPan[0],
          end_y: lastPan[1],
          batch_included_wheel: this.includedWheel,
          ...eventValue,
        });
      },
    );
  }

  private subscribeToWheel() {
    this.subscriptionManager.subscribeTo(
      fromEvent(this.target, 'wheel'),
      () => {
        this.includedWheel = true;
      },
    );
  }

  private reset() {
    this.includedWheel = false;
  }
}
